import React from "react"
import { Modal } from "antd"
import { CloseOutlined, DeleteOutlined } from "@ant-design/icons"
import { translations } from "../../../utils/Translation/staticTranslation"
import "./CreatePlan.css"

const PlanReceiptIcon = () => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <path
      d="M9 4H23C24.1 4 25 4.9 25 6V26C25 27.1 24.1 28 23 28H9C7.9 28 7 27.1 7 26V6C7 4.9 7.9 4 9 4Z"
      stroke="#FB6514"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11 10H21M11 14H21M11 18H17"
      stroke="#FB6514"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M16 21C17.6569 21 19 19.6569 19 18C19 16.3431 17.6569 15 16 15C14.3431 15 13 16.3431 13 18C13 19.6569 14.3431 21 16 21Z"
      stroke="#FB6514"
      strokeWidth="1.5"
    />
    <path
      d="M16 17V19M15 18H17"
      stroke="#FB6514"
      strokeWidth="1.2"
      strokeLinecap="round"
    />
  </svg>
)

const CreatePlanConfirmModal = ({
  open,
  variant,
  onClose,
  onConfirm,
  loading = false,
  titleOverride,
  buttonOverride,
}) => {
  const lang = localStorage.getItem("language") || "ar"
  const t = translations[lang]?.plansPricingPage?.createPlan?.modals

  const config = {
    confirm: {
      title: t?.confirm_title || "Confirm Plan",
      message:
        t?.confirm_message ||
        "Do you want to confirm this plan? This plan will be available for the users.",
      button: t?.confirm_button || "Confirm Plan",
      buttonClass: "create-plan-modal-btn-primary",
    },
    draft: {
      title: t?.draft_title || "Save as draft",
      message:
        t?.draft_message ||
        "Save your changes as a draft. You can update it later.",
      button: t?.draft_button || "Save Draft",
      buttonClass: "create-plan-modal-btn-draft",
    },
    cancel: {
      title: t?.cancel_title || "Cancel Plan",
      message:
        t?.cancel_message ||
        "By cancelling the plan, you will lose all changes. This action cannot be undone.",
      button: t?.cancel_button || "Cancel Plan",
      buttonClass: "create-plan-modal-btn-danger",
      showTrash: true,
    },
  }[variant]

  if (!config) return null

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      width={500}
      centered
      className="create-plan-confirm-modal"
      closeIcon={<CloseOutlined className="create-plan-confirm-modal-close" />}
      destroyOnClose
    >
      <div className="create-plan-confirm-content">
        <div className="create-plan-confirm-icon-wrap">
          <PlanReceiptIcon />
        </div>
        <h2 className="create-plan-confirm-title">
          {titleOverride || config.title}
        </h2>
        <p className="create-plan-confirm-message">{config.message}</p>
        <button
          type="button"
          className={`create-plan-confirm-action ${config.buttonClass}`}
          onClick={onConfirm}
          disabled={loading}
        >
          {config.showTrash && <DeleteOutlined />}
          {loading ? "..." : buttonOverride || config.button}
        </button>
      </div>
    </Modal>
  )
}

export default CreatePlanConfirmModal
